import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { hideModal } from "actions/modal";
import ImportIgPostsSheet from "./ImportIgPostsSheet";

const ImportIgPostsModal = ({ onImported, accountId }) => {
  const dispatch = useDispatch();
  const [sheetOpen, setSheetOpen] = useState(true);
  const close = () => dispatch(hideModal());

  const handleSheetOpenChange = (open) => {
    setSheetOpen(open);
    if (!open) {
      close();
    }
  };

  return (
    <ImportIgPostsSheet
      open={sheetOpen}
      onOpenChange={handleSheetOpenChange}
      onImported={onImported}
      accountId={accountId}
    />
  );
};

export default ImportIgPostsModal;
